let ConsultationResolved = require('./consultation_resolved');

exports.getPdfHtml = (type, data) => {

	switch(type) {
	  case 'consultation_resolved':
		  return ConsultationResolved.getPdfHtml(data);
	  default: return;
	    // code block
	}

}
